var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOutgoing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 267,
    height: 117,
    viewBox: "0 0 267 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0429688,
    y: 0.195312,
    width: 266.469,
    height: 116.422,
    rx: 12.8635,
    fill: "#E5F9FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M0.0429688 77.0224L252.094 46.33C259.758 45.3967 266.512 51.3782 266.512 59.0991V103.752C266.512 110.857 260.753 116.616 253.649 116.616H12.9064C5.80211 116.616 0.0429688 110.857 0.0429688 103.752V77.0224Z",
    fill: "#CCF3FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutgoing);
export default __webpack_public_path__ + "static/media/outgoing.6c699ff130b167c32fee8cdc51495216.svg";
export { ForwardRef as ReactComponent };